import { useField } from '@framework/form/field/useField.tsx';
import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { useHydratedCommunicationContent } from './useHydratedCommunicationContent.ts';

interface Props {
  selectedTypeId: string | null | undefined;
  disabled: boolean | null | undefined;
}

/**
 * useEffect centralizzato per la gestione della modifica ai
 * campi dopo l'idratazione (anteprima) della comunicazione.
 */
export function useHydrateCommunication(props: Props) {
  const { selectedTypeId, disabled } = props;
  const messageEdited = useWatch({ name: 'flMessaggioModificato' });
  const subjectEdited = useWatch({ name: 'flOggettoModificato' });

  const { isLoading, error, data } = useHydratedCommunicationContent({
    communicationTypeId: selectedTypeId,
    disabled: (messageEdited && subjectEdited) || disabled,
  });

  const messageField = useField('messaggio');
  const subjectField = useField('oggetto');
  const messageValue = useWatch({ name: 'messaggio' });
  const subjectValue = useWatch({ name: 'oggetto' });

  useEffect(() => {
    if (disabled) return;
    if (isLoading) return;
    if (error) return;
    if (!data) return;

    if (!messageEdited && messageValue !== data.messaggio) {
      messageField.setValue(data.messaggio);
    }
    if (!subjectEdited && subjectValue !== data.oggetto) {
      subjectField.setValue(data.oggetto);
    }
  }, [
    data,
    disabled,
    error,
    isLoading,
    messageEdited,
    messageField,
    messageValue,
    subjectEdited,
    subjectField,
    subjectValue,
  ]);

  return {
    isLoading,
    error,
    original: { message: data?.messaggio, subject: data?.oggetto },
  };
}
